import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { cn } from '../../lib/utils';

export interface VideoIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

interface VideoIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const VideoIcon = forwardRef<VideoIconHandle, VideoIconProps>(
  ({ className, size = 28, ...props }, ref) => {
    void ref;
    return (
      <div className={cn(className)} {...props}>
        <svg
          fill="none"
          height={size}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width={size}
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
          <rect x="2" y="6" width="14" height="12" rx="2" />
        </svg>
      </div>
    );
  }
);

VideoIcon.displayName = 'VideoIcon';

export { VideoIcon };
